/*
 Copyright 2024 BFB Labs

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

	  https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

import React from 'react';
import './FooterComponent.css'
import { Grid } from '@mui/material';

const FooterComponent = () => {
	const gridItemSizeXs = 12;

	return(
		<Grid container className="footer-background m-t-auto">
			<Grid item xs={ gridItemSizeXs } className='dis-flex justify-center'>
				<img src="./BfB_logo_white_powered_by.png" alt="BfB Logo" className="logo" />
			</Grid>
			<Grid item xs={ gridItemSizeXs }>
				<div className="information">
					<a className='text-white' rel="noopener noreferrer" target="_blank" href="https://www.bfb-labs.com/lumi-nova-privacy-policy ">Privacy Policy</a>
					&nbsp;|&nbsp;
					<a className='text-white' rel="noopener noreferrer" target="_blank" href="https://bfb-labs.com">BfB Labs © { new Date().getFullYear() }</a>
				</div>
			</Grid>
		</Grid>
	)
}

export default FooterComponent;